import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { FormLabel, Select, MenuItem } from '@mui/material';
import { useForm } from 'react-hook-form';
import request from '../../../services/Request';
import { Modal } from '../../../components/BootstrapToMUI';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Controller, useController } from 'react-hook-form';
import { FormControl, InputLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const updateAdress = '/machines/updateAdress';

export default function EditAlphModal(props) {
  const theme = useTheme();
  const { data, user, setReflesh, reflesh, setshow, id, ...rest } = props;

  const defaultValues = {
    ini_user_credit: data?.alphUserFields?.ini_user_credit || 0,
    refresh_credit: data?.alphUserFields?.refresh_credit || 0,
    refresh_period: data?.alphUserFields?.refresh_period || 0,
  };

  const {
    reset,
    handleSubmit,
    register,
    formState: { errors },
    control,
    watch,
  } = useForm({ defaultValues });

  const watchAllFields = watch();

  useEffect(() => {
    if (props.show) {
      reset(defaultValues);
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    console.log('date', formData.p_date);
    // return console.log('formData', formData);

    request({
      method: 'patch',
      url: `/alphUserFields`,
      data: {
        id: id,
        ini_user_credit: formData.ini_user_credit,
        refresh_credit: formData.refresh_credit,
        refresh_period: formData.refresh_period,
      },
    }).then(() => {
      Swal.fire({
        title: 'Success',
        text: 'User has been successfully updated',
        timer: 2000,
      });
      setshow(false);
      setReflesh(!reflesh);
    });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" sx={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <Box>
            <Box component="form" sx={{ width: '100%', mt: 3 }} onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2} sx={{ textAlign: 'center' }}>
                {/* <Select onChange={handleChange}>
                  {field.map((field) => (
                    <MenuItem key={field._id} value={field._id}>
                      {field.service}
                    </MenuItem>
                  ))}
                </Select> */}

                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.ini_user_credit || 0}
                    variant="outlined"
                    fullWidth
                    label="Initial User Credit"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('ini_user_credit', {})}
                  />
                  {errors.ini_user_credit && (
                    <Typography className="signUpErrorMessage">{errors.ini_user_credit.message}</Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.refresh_credit || 0}
                    variant="outlined"
                    fullWidth
                    label="Refresh Credit"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('refresh_credit', {})}
                  />
                  {errors.refresh_credit && (
                    <Typography className="signUpErrorMessage">{errors.refresh_credit.message}</Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    value={watchAllFields?.refresh_period || 0}
                    variant="outlined"
                    fullWidth
                    label="Refresh Period"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    {...register('refresh_period', {})}
                  />
                  {errors.refresh_period && (
                    <Typography className="signUpErrorMessage">{errors.refresh_period.message}</Typography>
                  )}
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
              >
                Update
              </Button>
            </Box>
          </Box>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
